import * as React from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Home, PersonAddAlt, PostAdd } from "@mui/icons-material";
import { NavLink } from 'react-router-dom';


function MainListItems()  {
    const [role, setRole] = React.useState(null);
    React.useEffect(() => {
        getRole();
        //eslint-disable-next-line
      }, []);
    const getUserDetails = () => {
        const token = sessionStorage.getItem("authToken");
        if (token !== null) {
          const decodeUserDetails = JSON.parse(
            window.atob(sessionStorage.getItem("authToken").split(".")[1])
          );
          return decodeUserDetails;
        }
        return null;
    };
    const getRole = () => {
        const tokenDetails = getUserDetails();
        if(tokenDetails != null)
            setRole(tokenDetails["Role"]);
        else
            setRole(null);
    };
    const translatedText = JSON.parse(sessionStorage.getItem("TranslationText"));
    return role === 'admin_role' ? (
        <React.Fragment>
            <ListItemButton component={NavLink} to='/layout/shipments'>
                <ListItemIcon>
                    <Home />
                </ListItemIcon>
                <ListItemText primary={translatedText?.my_shipments} />
            </ListItemButton>
            <ListItemButton component={NavLink} to='/layout/users'>
                <ListItemIcon>
                    <PersonAddAlt />
                </ListItemIcon>
                <ListItemText primary={translatedText?.users} />
            </ListItemButton>
            <ListItemButton component={NavLink} to='/layout/customerprofiles'>
                <ListItemIcon>
                    <PostAdd />
                </ListItemIcon>
                <ListItemText primary={translatedText?.customer_profiles} />
            </ListItemButton>
        </React.Fragment>
    ) :
    (
        <React.Fragment>
            <ListItemButton component={NavLink} to='/layout/shipments'>
                <ListItemIcon>
                    <Home />
                </ListItemIcon>
                    <ListItemText primary={translatedText?.my_shipments} />
            </ListItemButton>
        </React.Fragment>
    );
}

export default function Sidemenu() {
    return <MainListItems />;
  }